<main *ngIf="user?.id">
  <section class="design-area" id="service">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 text-center">
          <div class="section-title">
            <h4>{{ user.name }}'s Digital Visiting Card</h4>
            <h1>Digital Card View</h1>
          </div>
        </div>
      </div>
      <div class="row justify-content-center digital-cards">
        <div class="col-md-6 my-3">
          <div class="" style="padding: 0px">
            <div class="page-container">
              <div class="header">
                <div
                  class="company-section"
                  [style]="{ 'background-color': user.digital_card_color }"
                >
                  <img
                    [lazyLoad]="user.company?.logo"
                    alt="User image"
                    class="img-fluid company-logo"
                  />
                  <p class="text-center company-name">
                    {{ user.company?.name }}
                  </p>
                </div>
                <div class="profile">
                  <div class="row">
                    <div class="col-12">
                      <img
                        [lazyLoad]="user.profile"
                        alt="User image"
                        class="img-fluid pfp"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div
                    class="name_tit_bann_item"
                    [style]="{ 'background-color': user.digital_card_color }"
                  >
                    <div style="margin-top: 70px">
                      <p class="text-center m-0" class="name_tit_text">
                        {{ user.name }}
                      </p>
                      <p class="text-center" class="name_tit_text_dec">
                        {{ user.post_detail?.designation }}
                      </p>
                    </div>
                    <div class="address-section-inner">
                      <p>Address</p>
                      <p class="name_tit_bann_item_sub">
                        {{ user.company?.address }},{{ user.company?.city }},{{
                          user.company?.state.state
                        }},{{ user.company?.country.country }}
                      </p>
                    </div>
                    <div
                      class="text-center contact-info name_tit_bann_cont_view"
                    >
                      <p class=" ">
                        <a
                          (click)="
                            onActionBtnClick(
                              user.designation_name?.toLowerCase() == 'purchase'
                                ? 'personal_whatsapp_purchase'
                                : 'personal_whatsapp_sale',
                              user.company,
                              'https://api.whatsapp.com/send?phone={{
                            user.whats_app
                          }}&text=Hi,%20Got%20reference%20from%20GTI%20website'
                            )
                          "
                          ><span
                            ><img
                              lazyLoad="../../../assets/img/digital_whatsapp.png"
                              alt=""
                              class="img-fluid" /></span
                          >Whatsapp</a
                        >
                      </p>
                      <p class="  ">
                        <a
                          (click)="
                            onActionBtnClick(
                              user.designation_name?.toLowerCase() == 'purchase'
                                ? 'personal_call_purchase'
                                : 'personal_call_sale',
                              user.company,
                              '{{user.mobile}}'
                            )
                          "
                          ><span
                            ><img
                              lazyLoad="../../../assets/img/digital_call.png"
                              alt=""
                              class="img-fluid" /></span
                          >Call</a
                        >
                      </p>
                      <p class="">
                        <a (click)="onActionBtnClick('email',user.company,'mailto:{{ user.email }}')" 
                          ><span
                            ><img
                              lazyLoad="../../../assets/img/digital_email.png"
                              alt=""
                              class="img-fluid" /></span
                          >Email</a
                        >
                      </p>
                      <p class="">
                        <a (click)="onActionBtnClick('web',user.company,user.company?.website)" 
                          ><span
                            ><img
                              lazyLoad="../../../assets/img/digital_website.png"
                              alt=""
                              class="img-fluid" /></span
                          >Website</a
                        >
                      </p>
                    </div>
                    <div
                      class="text-center contact-info name_tit_bann_cont_view"
                    >
                      <p class=" ">
                        <a (click)="onActionBtnClick('view_catelouge',user.company)" 
                          ><span
                            ><img
                              lazyLoad="/assets/img/digi_cata.png"
                              alt=""
                              class="img-fluid" /></span
                          >Catalogue</a
                        >
                      </p>
                      <p class="  ">
                        <a (click)="onActionBtnClick('product_gellery',user.company)" 
                          ><span
                            ><img
                              lazyLoad="/assets/img/digi_gallary.png"
                              alt=""
                              class="img-fluid" /></span
                          >Product Gallery</a
                        >
                      </p>
                      <p class="">
                        <a (click)="onActionBtnClick('about_company',user.company)" 
                          ><span
                            ><img
                              lazyLoad="/assets/img/digi_about.png"
                              alt=""
                              class="img-fluid" /></span
                          >About Us</a
                        >
                      </p>
                    </div>
                    <div class="text-center contact-info contact-info-soc">
                      <h5>Share in Social Media</h5>
                      <p class=" ">
                        <span
                          ><a
                            [href]="whatsapp"
                            target="_blank"
                            data-action="share/whatsapp/share"
                            ><i
                              class="fa fa-whatsapp fa-2x"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </p>
                      <p class="  ">
                        <span
                          ><a [href]="facebook" target="_blank"
                            ><i
                              class="fa fa-facebook fa-2x"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </p>
                      <p class="">
                        <span
                          ><a [href]="twitter" target="_blank"
                            ><i
                              class="fa fa-twitter fa-2x"
                              aria-hidden="true"
                            ></i></a
                        ></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- design area end -->
</main>
